/**
 * The INTERN pill, with its location's state ("INTERN · CA"). Sits where the
 * gold BAM COACH pill sits (Tyler Clark's Intern Hub proposal). Renders
 * nothing for anyone who isn't an active intern, and nothing at all until
 * docs/intern-hub.sql has been run. One shared read per session
 * (interns/internApi.js), however many names are on screen.
 */
import React from "react";
import { useInternBadge } from "../interns/internApi";

export function InternBadge({ userId, size = "sm", style }) {
  const state = useInternBadge(userId);
  if (state === null || state === undefined) return null;
  const md = size === "md";
  return (
    <span aria-label={`BAM intern${state ? `, ${state}` : ""}`}
      style={{ display: "inline-flex", alignItems: "center", padding: md ? "3px 9px" : "1px 6px", borderRadius: 999,
        border: "1px solid #7FB7E0", color: "#7FB7E0", background: "rgba(127,183,224,0.12)",
        fontSize: md ? 11 : 9.5, fontWeight: 800, fontFamily: "'Bebas Neue',sans-serif", letterSpacing: md ? 1.2 : 0.8,
        lineHeight: 1.3, whiteSpace: "nowrap", flexShrink: 0, verticalAlign: "middle", ...style }}>
      INTERN{state ? ` · ${state}` : ""}
    </span>
  );
}

export default InternBadge;
